import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { request } from '../../../../services/request';
import { shouldReportErrorMonitor } from '../../Challenge/helpers/shouldReportErrorMonitor';
import { handleError } from '../../../ErrorHandler/errorHandlerPropsMap';
import { Namespace } from '@wix/ambassador-legends-persona-v1-chat/types';
import { queryChatMessages } from '@wix/ambassador-legends-persona-v1-chat/http';

export default async function (
  flowAPI: ControllerFlowAPI,
  chatId: string,
  store: any,
) {
  try {
    const messages =
      (
        await request({
          flowAPI,
          options: queryChatMessages({
            chatId,
            namespace: Namespace.EDUCATION,
          }),
          errorOptions: {
            errorCodesMap: { applicationError: {} },
          },
        })
      )?.data?.chatMessages || [];

    store.messages = [...messages];

    flowAPI.controllerConfig.setProps({
      messages,
    });
  } catch (error) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(error);

    handleError({
      error,
      resolvedError,
      context: 'GetChatMessages',
      preventErrorMonitorReport: !shouldReportErrorMonitor(error),
    });
  }
}
